export { default } from './DappSubmissionLayout';
